import { detectHVOrgConflicts } from '@app/pathway-shared';
import { ConfigKeyFE_OrganizationsParentTagId, ModuleFE_ContextRule, ModuleFE_Tag, ModuleFE_Variable } from '@app/hcs-frontend';
import { filterDuplicates, reduceToMap } from '@nu-art/ts-common';
import { ModuleFE_Pathway } from '../../../../../_entity.js';
// Frontend mirror of the backend HV+org uniqueness check, computed from caches for early UX.
// The backend remains authoritative (blocks on save); this only surfaces the violation sooner.
export const getPathwayHVOrgConflicts = (pathway) => {
    const variableIds = filterDuplicates(pathway.variableIds ?? []);
    if (!variableIds.length)
        return [];
    const orgParentTagId = ConfigKeyFE_OrganizationsParentTagId.get();
    if (!orgParentTagId)
        return [];
    const orgTags = ModuleFE_Tag.cache.filter(tag => tag.tagIds.includes(orgParentTagId));
    if (!orgTags.length)
        return [];
    const candidatePathways = ModuleFE_Pathway.cache.filter(candidate => candidate._id !== pathway._id && variableIds.some(id => (candidate.variableIds ?? []).includes(id)));
    if (!candidatePathways.length)
        return [];
    return detectHVOrgConflicts({
        pathway,
        candidatePathways,
        contextRules: ModuleFE_ContextRule.cache.all(),
        orgTagIds: orgTags.map(tag => tag._id),
        tagLabelById: reduceToMap(orgTags, tag => tag._id, tag => tag.label),
        variableNameById: reduceToMap(ModuleFE_Variable.cache.filter(variable => variableIds.includes(variable._id)), variable => variable._id, variable => variable.name),
    });
};
//# sourceMappingURL=hv-org-conflicts.js.map